import { render, staticRenderFns } from "./ChangeOwner.vue?vue&type=template&id=758a14de&scoped=true"
import script from "./ChangeOwner.vue?vue&type=script&lang=js"
export * from "./ChangeOwner.vue?vue&type=script&lang=js"
import style0 from "./ChangeOwner.vue?vue&type=style&index=0&id=758a14de&scoped=true&lang=css"
import style1 from "./ChangeOwner.vue?vue&type=style&index=1&id=758a14de&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758a14de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('758a14de')) {
      api.createRecord('758a14de', component.options)
    } else {
      api.reload('758a14de', component.options)
    }
    module.hot.accept("./ChangeOwner.vue?vue&type=template&id=758a14de&scoped=true", function () {
      api.rerender('758a14de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/ChangeOwner.vue"
export default component.exports